<template>
  <div
    class="single-file-upload"
    :class="{ 'has-img': showImg }"
  >
    <div
      class="content"
      :style="contentStyle"
    >
      <input
        type="file"
        class="file-el"
        ref="file"
        accceptaccept="acccept"
        @change="onChange"
      />
      <template v-if="!showImg && !disabled">
        <div class="icon-content">
          <i
            class="icon icon-xinzeng cursor"
            @click="onClick"
          ></i>
        </div>
        <div class="text">{{ text }}</div>
      </template>
      <img
        v-if="showImg"
        :src="getAttachUrl(value[0])|| (value[0]&&value[0].attachPath) "
        alt=""
        class="pre-img"
      />
      <div
        class="edit-content"
        v-if="showImg && !disabled"
      >
        <div class="edit-content-mask"></div>
        <div class="btn-group">
          <span class="edit">
            <i
              class="icon icon-bianji cursor"
              @click="onClick"
            ></i>
          </span>
          <span class="del">
            <i
              class="icon icon-shanchu cursor"
              @click="onDel"
            ></i>
          </span>
        </div>
      </div>
    </div>
    <div
      class="tips"
      v-if="tips"
    >{{ tips }}</div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    // array
    value: {
      required: true
    },
    bizId: {
      type: [String, Number],
      default: ''
    },
    bizType: {
      type: String,
      default: ''
    },
    acccept: {
      type: String,
      default: 'image/jepg, image/png, image/jpg'
    },
    limit: {
      type: Number,
      default: 500 * 1024 * 1024
    },
    contentStyle: {
      type: Object,
      default() {
        return {};
      }
    },
    tips: String,
    // 当true时，禁止编辑，删除，添加
    disabled: {
      type: Boolean,
      default: false
    },
    autoUpload: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    showImg() {
      return this.value && this.value.length;
    }
  },
  watch: {
    bizId: function () {
      this.getOssAttach();
    },
    bizType: function () {
      this.getOssAttach();
      this.getOssConfig();
    }
  },
  data() {
    return {
      filesCache: [],
      ossConfig: {}
    };
  },
  methods: {
    // 获取oss配置
    getOssConfig: function () {
      const folder = this.$getUploadFolder(this.bizType);
      this.$getJSON(apis.ossUpload, { folder }).then((res) => {
        this.ossConfig = res.data;
      });
    },
    onChange(e) {
      const file = e.target.files[0];
      if (file.size > this.limit) {
        this.$message.error(this.$message.error(this.$t('components_singleFileUpload.wjbncg500M')));
        return;
      }
      this.filesCache = [...this.$refs.file.files];
      this.$refs.file.value = '';
      if (this.autoUpload) {
        this.$postOss(file, this.ossConfig).then((res) => {
          const data = res.data;
          data.bizType = this.bizType;
          data.bizId = this.bizId;
          this.$emit('input', [data]);
          this.$emit('effect', [data]);
        });
      } else {
        file.uid = this.getUUID();
        this.getFilePreviewUrl(file).then((src) => {
          file.attachPath = src;
          this.$emit('input', [file]);
          this.$emit('effect', [file]);
        });
      }

    },
    submit() {
      if (this.filesCache.length) {
        if (this.value[0].attachId) {
          return Promise.resolve(this.getAttachUrl(this.value[0]));
        }
        const file = this.filesCache[0];
        return this.$postOss(file, this.ossConfig).then((res) => {
          const data = res.data;
          data.bizType = this.bizType;
          data.bizId = this.bizId;
          this.$emit('input', [data]);
          this.$emit('effect', [data]);
          return this.getAttachUrl(data);
        });
      }
      return Promise.resolve('');
    },
    onClick() {
      this.$refs.file.click();
    },
    getFile() {
      return this.filesCache.length ? this.filesCache[0] : '';
    },
    /**
     * ocr识别
     * @return {Promise} ret Promise.resolve(res.data)
     */
    ocr() {
      const file = this.getFile();
      if (file) {
        return this.$postFile(
          apis.businessLicenseOcr,
          {},
          { file: this.getFile() }
        ).then(res => res.data);
      }
      return Promise.reject(new Error('No selection'));
    },
    // 资源加载显示
    getOssAttach: function () {
      if (!this.bizId || !this.bizType) {
        return;
      }
      this.$getJSON(`${apis.OssAttach}/${this.bizId}/${this.bizType}`).then(
        (res) => {
          const list = res.data;
          list.forEach((item) => {
            item.name = item.attachName;
            item.url = this.getAttachUrl(item);
            item.bizType = this.bizType;
          });
          this.$emit('input', list);
          this.$emit('effect', list);
        }
      );
    },
    onDel() {
      this.$emit('input', []);
      this.$emit('effect', []);
    }
  },
  mounted() {
    this.getOssConfig();
    this.getOssAttach();
  }
};
</script>

<style lang="scss">
.single-file-upload {
  width: 100%;

  &.has-img {
    > .content {
      background: transparent;
      &:hover {
        .edit-content {
          opacity: 1;
        }
      }
    }
  }

  .cursor {
    cursor: pointer;
  }

  > .content {
    background: #f5f5f5;
    position: relative;
  }

  > .tips {
    color: #aeb5bd;
    font-size: 12px;
    line-height: 16px;
    margin-top: 16px;
  }

  .file-el {
    display: none;
  }

  .icon-content {
    text-align: center;
    .icon {
      font-size: 22px;
      color: #dee2e6;
    }
  }
  .text {
    margin-top: 8px;
    font-size: 12px;
    line-height: 22px;
    color: #98a6ad;
    text-align: center;
  }

  .pre-img {
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 100;
  }

  .edit-content {
    position: absolute;
    z-index: 1000;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    opacity: 0;
    transition: all 0.3s;

    .edit-content-mask {
      z-index: 0;
      position: absolute;
      background: #000;
      opacity: 0.4;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }

    .btn-group {
      transform: translate3d(0, -50%, 0);
      top: 50%;
      position: relative;
      text-align: center;
      border: none !important;
      > span {
        display: inline-block;
        .icon {
          font-size: 20px;
          color: #fff;
        }
        + span {
          margin-left: 15px;
        }
      }
    }
  }
}
</style>
